/**
 * LOGOI LAB - Application Entry Point
 * 
 * @author Dr. José Manuel Cadena Ortiz de Montellano
 * @framework Cadena Strategic Systems
 * @version 3.1.0 — Interactive slider tooltips
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import './index.css';
import './styles/responsive.css';

window.__LOGOS_BUILD__ = '3.1.0';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
